export default function LogoutPage() {
  return (
    <>
      <main>Cerrando sesión...</main>
    </>
  );
}
